<template>
  <!-- ตัวโหลด: นก depa บินวนเป็นวงกลม พร้อมหางประกายสีเหลืองจางๆ
       finishing = true: วนต่อจนครบรอบที่บินอยู่ แล้วขยายนิดหนึ่งพร้อมจางหาย จากนั้น emit 'done' -->
  <div class="bird-orbit" :style="{ width: `${size}px`, height: `${size}px` }" role="img" aria-label="กำลังโหลด">
    <div
      ref="spin"
      class="bird-orbit__spin"
      :class="{ 'bird-orbit__spin--leaving': leaving }"
      @animationend="onLeaveEnd"
    >
      <div class="bird-orbit__trail"></div>
      <!-- อยู่บนสุดของวง หันหัวไปทางขวา = ทิศที่บินเมื่อวนตามเข็มนาฬิกา -->
      <div class="bird-orbit__bird">
        <depa-bird :size="birdSize" flap></depa-bird>
      </div>
    </div>
  </div>
</template>

<script>
import DepaBird from './DepaBird.vue';
import { motionEnabled } from '@/fun/settings';

const LAP_MS = 1600;

export default {
  name: 'BirdOrbit',
  components: { DepaBird },
  props: {
    size: { type: Number, default: 140 },
    finishing: { type: Boolean, default: false },
  },
  data() {
    return { leaving: false, timer: null, startedAt: 0 };
  },
  computed: {
    birdSize() {
      return Math.round(this.size * 0.22);
    },
  },
  watch: {
    finishing: {
      immediate: true,
      handler(value) {
        if (value) this.finish();
      },
    },
  },
  mounted() {
    this.startedAt = performance.now();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    // เวลาที่เหลือจนครบรอบปัจจุบัน (ใช้เวลาจริงของแอนิเมชันถ้าเบราว์เซอร์บอกได้)
    remainingInLap() {
      const el = this.$refs.spin;
      const anim = el && el.getAnimations ? el.getAnimations()[0] : null;
      const elapsed = anim && typeof anim.currentTime === 'number'
        ? anim.currentTime
        : performance.now() - this.startedAt;
      return LAP_MS - (elapsed % LAP_MS);
    },
    finish() {
      if (!motionEnabled()) {
        this.$emit('done');
        return;
      }
      clearTimeout(this.timer);
      this.$nextTick(() => {
        this.timer = setTimeout(() => { this.leaving = true; }, this.remainingInLap());
      });
    },
    onLeaveEnd(e) {
      if (this.leaving && e.animationName && e.animationName.indexOf('bird-orbit-leave') !== -1) {
        this.$emit('done');
      }
    },
  },
};
</script>

<style scoped>
.bird-orbit {
  position: relative;
}

.bird-orbit__spin {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: bird-orbit-spin 1.6s linear infinite;
}

/* ครบรอบแล้ว: หยุดที่จุดบนสุด ขยายนิดหนึ่งและจางหาย */
.bird-orbit__spin--leaving {
  animation: bird-orbit-leave 0.3s ease-out forwards;
}

/* หางประกาย: วงแหวนที่จางจากสีเหลืองตรงตัวนกไปถึงโปร่งใสด้านหลัง */
.bird-orbit__trail {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: conic-gradient(from 0deg, rgba(255, 198, 0, 0) 0deg, rgba(255, 198, 0, 0) 150deg, rgba(255, 242, 0, 0.9) 350deg, rgba(255, 242, 0, 0) 360deg);
  -webkit-mask: radial-gradient(circle, transparent 60%, #000 61%, #000 66%, transparent 67%);
  mask: radial-gradient(circle, transparent 60%, #000 61%, #000 66%, transparent 67%);
}

.bird-orbit__bird {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -38%);
  line-height: 0;
}

@keyframes bird-orbit-spin {
  to { transform: rotate(360deg); }
}

@keyframes bird-orbit-leave {
  from { transform: rotate(0deg) scale(1); opacity: 1; }
  to { transform: rotate(0deg) scale(1.15); opacity: 0; }
}

/* ปิดแอนิเมชัน: นกนิ่งอยู่ด้านบน ไม่มีหาง */
html.no-motion .bird-orbit__spin {
  animation: none;
}

html.no-motion .bird-orbit__trail {
  display: none;
}
</style>
